exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".articleAbstract[data-v-fb1ec058],.articleTitle[data-v-fb1ec058],.articleType[data-v-fb1ec058]{width:80%}.articleAuthor[data-v-fb1ec058]{width:100%}.articleContent[data-v-fb1ec058]{width:98%}.containVideo[data-v-fb1ec058]{position:absolute;top:20px;left:450px}.ql-container[data-v-fb1ec058]{min-height:400px}.gray[data-v-fb1ec058]{color:#999}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-fb1ec058&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/yunying/article/newArticle.vue
// module id = 646
// module chunks = 0